import { defineComponent as _defineComponent } from 'vue'
import { RouteAvailable } from '@/packages/vue-router-permissions'


export default /*@__PURE__*/_defineComponent({
  __name: 'SidebarMenuLink',
  props: {
    to: {},
    href: {},
    disabled: { type: Boolean },
    hasChild: { type: Boolean, default: false }
  },
  emits: ["clicked"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();


const emit = __emit

const __returned__ = { emit, get RouteAvailable() { return RouteAvailable } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})